import { Trans, useTranslation } from 'react-i18next';

import Button from '../../../../components/Button/Button';
import LinkButton from '../../../../components/LinkButton/LinkButton';

import useSelectedSpace from '../../../../hooks/useSelectedSpace';

import { GridIcon } from '../../../../images/shapes';

export interface DisabledPluginSectionProps {
  /**
   * Name of the disabled plugin, displayed in the heading and description.
   */
  pluginName: string;
  /**
   * Callback removing the panel from the dashboard.
   */
  onRemove: () => void;
}

const DisabledPluginSection = ({
  pluginName,
  onRemove,
}: DisabledPluginSectionProps) => {
  const { t } = useTranslation();
  const { buildUrlWithSpace } = useSelectedSpace();

  return (
    <section>
      <h2 className="text-xl text-slate-900 dark:text-slate-200">
        {pluginName}
      </h2>
      <div
        className="mt-2 p-6 rounded-lg text-center bg-white flex flex-col items-center
       justify-center dark:bg-slate-950"
      >
        <div
          className={
            'shrink-0 mb-5 flex size-12 items-center justify-center rounded-md ' +
            'bg-blue-50 dark:bg-blue text-blue dark:text-slate-200'
          }
          aria-hidden="true"
        >
          <GridIcon className="size-5" />
        </div>
        <h2 className="text-lg font-semibold text-slate-900 dark:text-slate-200">
          {t('Home.DisabledPlugin.Title')}
        </h2>
        <p className="mt-2 text-base max-w-prose text-slate-500 dark:text-slate-400">
          <Trans
            i18nKey="Home.DisabledPlugin.Description"
            values={{ pluginName }}
            components={{ strong: <strong className="font-semibold" /> }}
          />
        </p>
        <div className="mt-5 flex flex-wrap gap-3" data-no-drag>
          <Button
            buttonColor="borderlessBlue"
            onClick={onRemove}
            additionalClasses="hover:opacity-100 dark:text-blue"
          >
            {t('Home.DisabledPlugin.RemovePanel')}
          </Button>
          <LinkButton buttonColor="blue" link={buildUrlWithSpace('plugins')}>
            {t('Home.DisabledPlugin.ManagePlugins')}
          </LinkButton>
        </div>
      </div>
    </section>
  );
};

export default DisabledPluginSection;
